import { Root } from 'react-dom/client';
import { FormattedMessage, useIntl } from 'react-intl';
import { Icon, Tooltip } from '@ets/design-system';

import DOMElementFactory from 'Editor/services/DOMUtilities/DOMElementFactory/DOMElementFactory';
import { DISPLAY_TYPES, ELEMENTS } from 'Editor/services/consts';
import styles from './AuthorsElement.module.scss';
import { BaseBlockElement } from '../../BaseViewBuilder';
import { StylesUtils } from 'Editor/services/Edition_v2/Managers/Styles/StylesUtils';
import ReactUtils from '_common/utils/ReactUtils';

const AuthorsElementContent = () => {
  const intl = useIntl();

  return (
    <Tooltip
      content={intl.formatMessage({ id: 'CONTENT_CANNOT_BE_EDITED' })}
      testId="authors-cannot-be-edited"
    >
      <div className={styles.contentWrapper}>
        <div className={styles.iconWrapper}>
          <Icon icon="list" size="4" testId="authors" />
        </div>
        <div className={styles.info}>
          <FormattedMessage id={'EDITOR_DOCUMENT_AUTHORS'} />
        </div>
      </div>
    </Tooltip>
  );
};

export class AuthorsElement extends BaseBlockElement {
  private container?: HTMLElement;
  private rootReactContainer?: Root;

  get selectableContent() {
    if (this.container) {
      return this.container.childNodes[0]?.childNodes[1];
    }
    return null;
  }

  connectedCallback() {
    super.connectedCallback();
    this.buildElement();
  }

  disconnectedCallback() {
    ReactUtils.unmountReactComponent(this.rootReactContainer);
    super.disconnectedCallback();
  }

  get ALLOWED_STYLE_ATTRIBUTES() {
    return StylesUtils.getAllowedBlockStyles('a');
  }

  get displayType() {
    return DISPLAY_TYPES.BLOCK;
  }

  get isEditable() {
    return false;
  }

  get isDeletable() {
    return !this.isLocked;
  }

  get isSplitable() {
    return false;
  }

  get isSelectable() {
    return true;
  }

  buildElement() {
    this.innerHTML = '';

    this.setAttribute('spellcheck', 'false');

    this.container = DOMElementFactory.buildElement('div');
    this.container.setAttribute('class', styles.container);

    this.appendChild(this.container);

    this.rootReactContainer = ReactUtils.createReactRoot(this.container);
    ReactUtils.renderReactComponent(<AuthorsElementContent />, this.rootReactContainer);
  }
}

if (!window.customElements.get(ELEMENTS.AuthorsElement.IDENTIFIER)) {
  window.customElements.define(ELEMENTS.AuthorsElement.IDENTIFIER, AuthorsElement);
}
